export default "__VITE_ASSET__SOZJqwcT__"